import React, { Component } from 'react'
import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit,faCheckCircle, faTimesCircle, faPen} from '@fortawesome/free-solid-svg-icons';
import LaunchTraining from './LaunchTraining';
import './EmplTraining.css';
import { Util } from '../../../config/Util';
import axios from 'axios';
import {API} from '../../../config/API';
import Loader from '../../../components/Loader/Loader';

export default class EmplTraining extends Component {
  
constructor(){
    super();
    this.rowData = {};
    this.columns = [
      {
          name: 'ID',
          selector: row => row.id, 
          center:true,
          grow:0.5
      },
      {
          name: 'TITLE',
          selector: row => row.name,
          grow:3,
          center:true
      },
      {
        name: 'DUE DATE',
        selector: row => row.dueDate,
        center:true
      },
      {
        id:"status",
        center:true,
        name:"STATUS",
        cell: props => {
          return props.status !== 'NotCompleted' ? 
              <button disabled id={props.id} className='btn btn-success'  > 
              <FontAwesomeIcon icon={faCheckCircle} className='table-icon-inline'/> COMPLETED</button>
          : <button disabled id={props.id} className='btn btn-danger' > 
          <FontAwesomeIcon icon={faTimesCircle} className='table-icon-inline'/> PENDING</button>

       },
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        minWidth:"150px"
      },
      {
        
        minWidth:"150px",
        cell: props => {
          return props.status === 'NotCompleted' ? 
              <button  id={props.id} className='btn btn-info'  onClick={()=>this.launch(props)}> 
              <FontAwesomeIcon icon={faPen} className='table-icon-inline'/> LAUNCH</button>:''
        },
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
    
  ]
    this.state = {
      data : [],
      fullData:[],
      toggleForm : false,
      toggleAssignForm : false,
      toggleAddForm:false,
      editForm :  false,
      loader : false,
      certUrl :''
    }
    this.trainingDetailObj = {};
    
}

//Search fn
filterData = (e)=>{
  const key = e.target.value;
  let ar=[];
  this.state.fullData.forEach(element => {
    if(element.name.toLowerCase().indexOf(key.toLowerCase())>-1) 
    ar.push(element);
  });
  this.setState({data : ar})
}

launch =(props)=>{
  this.rowData = props;
  this.setState({loader : true});
  axios.get(API.getTrainingDetail+props.id).then((res)=>{
    if(res && res.data && res.data.status ==='S'){
      this.trainingDetailObj = res.data;
    }
  }).catch((er)=>{

  }).finally(()=>{
    this.setState({toggleForm : true});
    this.setState({loader : false});
  })
    
}
updateToggleFormVal = ()=>{
  this.setState({toggleForm : false});
}
componentDidMount(){
  this.loadData();
}

getUserDetails=(id)=>{
  axios.get(API.getUserDetail+id).then((res)=>{
      if(res.data && res.data.status ==='S'){
          Util.saveToSession("userData",res.data);
      }
      this.setState({loader:false});
  }).catch((er)=>{
      this.setState({loader:false});
  }).finally(()=>{
    this.loadData();
  })
}

loadData =()=>{
  let trainings = [];
  let d = Util.getFromSession("userData");
  if(d && d.trainings && d.trainings.length) trainings=d.trainings;

  this.setState({data:trainings});
  this.setState({fullData: trainings});
}

updateTrainingStatus = ()=>{
  this.setState({loader : true});
  let user = Util.getFromSession("userData");
  const req = {
    trainingId: this.rowData.id,
    userId: user.id,
    status: 'Complete'
  };
  axios.post(API.updateTrainingStatus,req).then((res)=>{
    if(res && res.data && res.data.status ==='S'){
      this.setState({certUrl:res.data.certificateUrl});
      this.getUserDetails(user.id);
    }
  }).catch((er)=>{

  }).finally(()=>{
    this.setState({loader : false});
  })
}


  render() {
    
    return (
      <div>
      <Loader loading={this.state.loader}></Loader>
      {this.state.toggleForm ? <LaunchTraining cert={this.state.certUrl} updateStatus={this.updateTrainingStatus} data={this.trainingDetailObj} handler={this.updateToggleFormVal} flag={this.state.toggleForm? true : false}/> : ''}

      <div className='bread-crumb overflow-auto'>
      <div>
      <span className='breadcrumb-title'>
        <input type='button' className='btn' value='Home - Training'></input>
      </span>
     
      </div>
      </div>
      <div className='data-table-holder'>
        <div className='table-search-box'>
        <input type='text' placeholder="Search Here.." className='form-control' onChange={(e)=>this.filterData(e)}></input>
        </div>
      <DataTable subHeaderAlign="center"
      columns={this.columns}
      data={this.state.data} pagination striped
     
      />
      </div>
      </div>
    )
  }
}
